export var UserAccessFeatureFlag;
(function (UserAccessFeatureFlag) {
    UserAccessFeatureFlag["CYBER_ASSESSMENTS_TOOL"] = "CYBER_ASSESSMENTS_TOOL";
    UserAccessFeatureFlag["INSIGHTS_TOOL"] = "INSIGHTS_TOOL";
    UserAccessFeatureFlag["MEIA_STUDIO_V1"] = "MEIA_STUDIO_V1";
    /** @deprecated MEIA Studio V2 (Studies) is retired. Kept as a valid flag for back-compat; remove in a follow-up iteration. */
    UserAccessFeatureFlag["MEIA_STUDIO_V2"] = "MEIA_STUDIO_V2";
    UserAccessFeatureFlag["ORG_SWITCHER"] = "ORG_SWITCHER";
    UserAccessFeatureFlag["RESEARCH_TOOL"] = "RESEARCH_TOOL";
    UserAccessFeatureFlag["THREADS_TOOL"] = "THREADS_TOOL";
    UserAccessFeatureFlag["TRL_PREDICTION"] = "TRL_PREDICTION";
})(UserAccessFeatureFlag || (UserAccessFeatureFlag = {}));
export var UserAccessRole;
(function (UserAccessRole) {
    UserAccessRole["ADMIN"] = "ADMIN";
    UserAccessRole["EXPERT"] = "EXPERT";
    UserAccessRole["INTELLIGENCE"] = "INTELLIGENCE";
    UserAccessRole["INNOVATOR"] = "INNOVATOR";
})(UserAccessRole || (UserAccessRole = {}));
